// components/ProductDisplay.jsx - Main Display Component
import React from 'react';
import SimpleReactLightbox from 'simple-react-lightbox';
import CustomerProducts from './CustomerProducts';
import TeammateProducts from './TeammateProducts';
import EmptyProducts from './EmptyProducts';

const ProductDisplay = ({ displayProducts = [], user = {}, gold = {}, translate = (key) => key, onDelete, deleteThisProductId }) => {
  if (!displayProducts || displayProducts.length === 0) {
    return <EmptyProducts />;
  }

  const isTeammate = Object.entries(user).length !== 0 && user['is_teammate'];

  return (
    <SimpleReactLightbox>
      <div className='product-display-container'>
        {isTeammate ? (
          <TeammateProducts displayProducts={displayProducts} user={user} translate={translate} onDelete={onDelete} deleteThisProductId={deleteThisProductId} />
        ) : (
          <CustomerProducts displayProducts={displayProducts} user={user} gold={gold} translate={translate} onDelete={onDelete} deleteThisProductId={deleteThisProductId} />
        )}
      </div>
    </SimpleReactLightbox>
  );
};

export default ProductDisplay;
